import { render, staticRenderFns } from "./InputCurrencyField.vue?vue&type=template&id=267c2f50&scoped=true"
import script from "./InputCurrencyField.vue?vue&type=script&lang=js"
export * from "./InputCurrencyField.vue?vue&type=script&lang=js"
import style0 from "./InputCurrencyField.vue?vue&type=style&index=0&id=267c2f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267c2f50",
  null
  
)

export default component.exports